import { makeStyles, fade } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    border: `solid 1px ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.custom.background.area,
    width: '100%',
    display: 'flex',
    marginBottom: theme.spacing(1 / 2),
    textDecoration: 'none',

    '& .lesson': {
      '&-content': {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        minHeight: theme.spacing(5),
        width: '100%',
        padding: theme.spacing(0, 1),
      },
      '&-text': {
        '&-container': {
          display: 'flex',
          alignItems: 'center',
          flexGrow: 1,
          overflow: 'hidden',
          padding: theme.spacing(0, 2, 0, 1),

          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            margin: theme.spacing(1, 0),
          },
        },
        '&-title': {
          display: 'flex',
          flexGrow: 1,
          justifyContent: 'flex-start',
          fontWeight: theme.typography.fontWeightMedium,
          textAlign: 'left',
        },
      },
      '&-infos': {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.hint,

        '&-icon': {
          '&-lock': {
            display: 'flex',
            marginRight: theme.spacing(2),
            color: theme.palette.primary.main,
          },
          '&-go': {
            color: theme.palette.primary.main,
          },
        },

        [theme.breakpoints.up('md')]: {
          position: 'absolute',
          height: '100%',
          right: 0,
          top: 0,
          backgroundColor: theme.palette.custom.background.area,
          opacity: 0,
          pointerEvents: 'none',
          padding: theme.spacing(0, 2),
        },
        [theme.breakpoints.down('sm')]: {
          marginTop: theme.spacing(1),
        },
      },
    },

    '&:hover': {
      [theme.breakpoints.up('xs')]: {
        '& .lesson': {
          '&-infos': {
            opacity: 1,
            pointerEvents: 'all',
          },
        },
      },
    },

    '&.next': {
      color: theme.palette.primary.main,
      borderColor: fade(theme.palette.primary.main, 0.38),
      backgroundColor: theme.palette.custom.background.area,

      '& .lesson': {
        '&-content': {
          backgroundColor: fade(theme.palette.primary.main, 0.08),
        },
        '&-icon': {
          color: theme.palette.primary.main,
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
        },
        '&-text': {
          '&-title': {
            color: theme.palette.primary.main,
          },
        },
      },

      '&:hover': {
        '& .lesson': {
          '&-content': {
            backgroundColor: fade(theme.palette.primary.main, 0.16),
          },
        },
      },
    },
    '&.completed': {
      color: theme.palette.secondary.main,
      borderColor: fade(theme.palette.custom.feedback.positive, 0.38),
      backgroundColor: theme.palette.custom.background.area,

      '& .lesson': {
        '&-content': {
          backgroundColor: fade(theme.palette.custom.feedback.positive, 0.08),
        },
        '&-icon': {
          color: theme.palette.custom.feedback.positive,
        },
        '&-text': {
          '&-container': {
            '&-title': {
              color: theme.palette.text.hint,
            },
          },
        },
        '&-infos': {
          '&-icon': {
            '&-go': {
              color: theme.palette.custom.feedback.positive,
            },
          },
        },
      },

      '&:hover': {
        '& .lesson': {
          '&-content': {
            backgroundColor: fade(theme.palette.custom.feedback.positive, 0.16),
          },
        },
      },
    },
  },
}));

export default styles;
